import React from "react";

import client1 from "../../assets/clients/1.jpeg";
import client2 from "../../assets/clients/2.jpeg";
import client3 from "../../assets/clients/3.jpeg";
import client4 from "../../assets/clients/4.jpeg";
import client5 from "../../assets/clients/5.jpeg";
import client6 from "../../assets/clients/6.jpeg";
import client7 from "../../assets/clients/7.png";
import client8 from "../../assets/clients/8.png";
import client9 from "../../assets/clients/9.png";
import client10 from "../../assets/clients/10.png";
import client11 from "../../assets/clients/11.jpeg";
import client12 from "../../assets/clients/12.jpeg";
import client13 from "../../assets/clients/13.jpeg";

const clients = [
  { id: 1, imageUrl: client1, alt: "Client logo 1" },
  { id: 2, imageUrl: client2, alt: "Client logo 2" },
  { id: 3, imageUrl: client3, alt: "Client logo 3" },
  { id: 4, imageUrl: client4, alt: "Client logo 4" },
  { id: 5, imageUrl: client5, alt: "Client logo 5" },
  { id: 6, imageUrl: client6, alt: "Client logo 6" },
  { id: 7, imageUrl: client7, alt: "Client logo 7" },
  { id: 8, imageUrl: client8, alt: "Client logo 8" },
  { id: 9, imageUrl: client9, alt: "Client logo 9" },
  { id: 10, imageUrl: client10, alt: "Client logo 10" },
  { id: 11, imageUrl: client11, alt: "Client logo 11" },
  { id: 12, imageUrl: client12, alt: "Client logo 12" },
  { id: 13, imageUrl: client13, alt: "Client logo 13" },
];

const stripGapClass = "flex shrink-0 items-center gap-6 md:gap-10 lg:gap-12";

const logoSlotClass =
  "flex h-20 w-[42vw] max-w-[200px] shrink-0 items-center justify-center px-4 sm:h-24 sm:w-[180px] md:h-28 md:w-[200px] lg:h-32 lg:w-[220px] xl:w-[240px]";

function LogoStrip({ list, stripIndex }) {
  return (
    <div className={stripGapClass} aria-hidden={stripIndex > 0 || undefined}>
      {list.map((client) => (
        <div
          key={`${stripIndex}-${client.id}`}
          className={`${logoSlotClass} transition-transform duration-300 hover:scale-105`}
        >
          <img
            src={client.imageUrl}
            alt={stripIndex === 0 ? client.alt : ""}
            className="max-h-14 w-auto max-w-full object-contain brightness-90 transition-all duration-300 hover:brightness-100 sm:max-h-16 md:max-h-20 lg:max-h-24 xl:max-h-28"
            draggable={false}
            loading="lazy"
            decoding="async"
          />
        </div>
      ))}
    </div>
  );
}

function OurClients() {
  return (
    <section className="relative border-t border-white/[0.06] bg-surface py-16 md:py-20 lg:py-24 overflow-hidden">
      <div className="container relative z-10 mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-12 text-center md:mb-16">
          <h2 className="text-3xl font-bold text-white md:text-4xl lg:text-5xl">
            Our <span className="text-gradient-brand">Clients</span>
          </h2>
        </div>
      </div>

      <div
        className="clients-marquee-wrap relative w-full [mask-image:linear-gradient(to_right,transparent_0%,black_8%,black_92%,transparent_100%)] [-webkit-mask-image:linear-gradient(to_right,transparent_0%,black_8%,black_92%,transparent_100%)] motion-reduce:[mask-image:none] motion-reduce:[-webkit-mask-image:none]"
        role="region"
        aria-label="Client logos, scrolling"
      >
        <div className="overflow-hidden">
          <div className="clients-marquee-animate flex w-max will-change-transform">
            <LogoStrip list={clients} stripIndex={0} />
            <LogoStrip list={clients} stripIndex={1} />
          </div>
        </div>
      </div>
    </section>
  );
}

export default OurClients;
